import ClipLoader from "react-spinners/ClipLoader";

interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    body: React.ReactNode;
    confirmLabel: string;
    requiredText: string;
    busy: boolean;
    confirmText: string;
    setConfirmText: (value: string) => void;
    onConfirm: () => void;
    onClose: () => void;
    cancelText: string;
}

export const ConfirmationDialog = ({
    open,
    title,
    body,
    confirmLabel,
    requiredText,
    busy,
    confirmText,
    setConfirmText,
    onConfirm,
    onClose,
    cancelText
}: ConfirmationDialogProps) => {
    if (!open) return null;

    const matches = confirmText === requiredText;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-jtc-very-dark-grey bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-xl w-96">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">{title}</h4>
                <p className="text-gray-600 text-sm mb-4">
                    {body}
                </p>
                <input
                    type="text"
                    value={confirmText}
                    onChange={(e) => setConfirmText(e.target.value)}
                    className="border p-2 rounded-md w-full mb-4 focus:ring-2 focus:ring-jtc-pink"
                />
                <div className="flex justify-end gap-4">
                    <button
                        className={`jtc-primary-button transition ${busy
                            ? "bg-jtc-pink cursor-not-allowed"
                            : !matches
                                ? "bg-jtc-pink opacity-50 cursor-not-allowed"
                                : "bg-jtc-pink hover:bg-jtc-purple"
                            }`}
                        onClick={onConfirm}
                        disabled={busy || !matches}
                    >
                        {busy ? (
                            <div className="flex items-center justify-center">
                                <ClipLoader size={16} color="white" />
                            </div>
                        ) : (
                            confirmLabel
                        )}
                    </button>
                    <button
                        className="jtc-secondary-button transition"
                        onClick={onClose}
                    >
                        {cancelText}
                    </button>
                </div>
            </div>
        </div>
    );
};
